import * as React from 'react';
import { bs4AddSnackbar, dismissToTime } from './Bs4Snackbar'
import Bs4MainWindow from './Bs4MainWindow'
import Bs4AppBar from './Bs4AppBar/Bs4AppBar'
import Bs4Kartoteka from './Bs4Kartoteka'
import Bs4Stores from './Bs4Stores'
import { geolocation } from './Bs4Geolocation'
import preval from 'preval.macro'

import {EventEmit} from './Bs4Components/Bs4Utils'
import * as Bs4Utils from './Bs4Components/Bs4Utils'
import { Bs4UxTemplates } from './Bs4Theme/Bs4UxTemplates';
import Bs4I18N from './Bs4I18N';
import pl from 'date-fns/locale/pl';
import { plPL } from '@mui/x-date-pickers/locales/';
import { setDefaultOptions } from 'date-fns';
import { colorIsDark } from './Bs4Components/Bs4Utils'

window.bslink = (cmd, details) => {
  Bs4MainDispatch.commandParserWait = {cmd, details };
  console.log('=== bslink ===', cmd, details)
}

// http://localhost/bs4/bs4core_jw2/krontask.php?do501upgrade=1

// function sleep(ms) {
//   return new Promise(resolve => setTimeout(resolve, ms))
// }

export default class Bs4MainDispatch {  

  static ASK_TO_CONFIRM = 'ASK_TO_CONFIRM';
  static WEB_PHP = 'web.php';
  static WEB_PHP_COM = 'web.php?com';
  static BS4_TOP_MSGS_REFRESH = 'bs4TopMsgsRefresh';
  static buildDate = preval`module.exports = new Date()`;
  static commandParserWait = null;
  static lastCommandParserAfterRow = null;
  static eventEmit = new EventEmit();
  static EVENTEMITLOCALE = 'eventEmitLocale';

  static on(name, onFunction) {
    this.eventEmit.on(name, onFunction);  
  }

  static off(onFunction) {
    this.eventEmit.off(onFunction);  
  }

  static trigger(name, ...params) {
    this.eventEmit?.trigger(name, ...params)
  }

  
  
  static speedPrefix = '...speed...';
  static speedStartTimeDate = null;
  static speedNextTimeDate = null;
  static getSpeedTime = (time) => {
    const min = time % (60 * 1000);    
    return (min / 1000.0).toFixed(3);
  }
  static speedTestTag = (tag, starts) => {
    if (!tag || !starts) return false;
    try {
      return tag.startsWith(starts)
    } catch(error) {
      console.log(this.speedPrefix+'error', error)
    }
  }
  static speedBs4KarOpt = (bs4KartotekaId, optionId) => {
    const id = bs4KartotekaId ? bs4KartotekaId.split('.')[1] : '?';
    return id+' '+optionId;
  }
  static speedStartTime = (text = '') => {
    this.speedStartTimeDate = Date.now();
    this.speedNextTimeDate = this.speedStartTimeDate;
    return this.speedPrefix+' START '+text;
  }
  static speedNextTime = (text = '') => {
    const ts = Date.now();
    const tnStart = ts - this.speedStartTimeDate;
    const tnNext = ts - this.speedNextTimeDate;
    this.speedNextTimeDate = ts;
    return this.speedPrefix+' '+this.getSpeedTime(tnStart)+' '+this.getSpeedTime(tnNext)+' '+text;
  }
  static speedRuneDisabled = true;
  static speedRun = (run, tag, disabled) => {    
    // if (!(
    //   this.speedTestTag(tag, '..Type_1') || 
    //   this.speedTestTag(tag, '..MenuH..')
    // )) return; 
    if (this.speedRuneDisabled || disabled) return;
    run(tag);
  }




  
  static stringToColor = (string) => {
    let hash = 0;
    let i;
  
    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
  
    let color = '#';
  
    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */
  
    return color;
  }
  
  static stringToInitials = (initials, label) => {
    if (initials) return initials;
    const string = ((label || '')+'').trim();
    const stringArray = string.split(' ');
    try {      
      return `${stringArray[0][0]}${stringArray[1][0]}`;  
    } catch(error) {
      return stringArray[0][0];
    }
  }

  static avatarDictionary = {};

  static getAvatar = (avatar, setAvatar) => {    
    //fileId = "5001087-6766a0b835df91993859d6fcdd2a1b55";

    const label = (avatar.label || '').trim();
    const key = avatar.fileId || label;        

    if (!key) {      
      const newAvatar = {
        ...avatar,
        bgcolor: 'transparent',
        textColor: 'transparent',
      };
      if (setAvatar) setAvatar(newAvatar);
      return newAvatar;
    }
    
    const newAvatar = Bs4MainDispatch.avatarDictionary[key];
    if (newAvatar) {
      if (setAvatar) setAvatar({...newAvatar});
      if (!newAvatar.imageBlobUrl && setAvatar) newAvatar.setArray.push(setAvatar);
      return {...newAvatar};
    } else {      
      avatar.initials = Bs4MainDispatch.stringToInitials(avatar.initials, label);
      avatar.bgcolor = Bs4MainDispatch.stringToColor(label);
      avatar.textColor = colorIsDark(avatar.bgcolor) > 0.5 ? '#000000f8' : '#fffffff8';
      avatar.imageBlobUrl = null;      
      if (setAvatar) setAvatar({...avatar});
      if (avatar.fileId) {
        avatar.setArray = [];
        if (setAvatar) avatar.setArray.push(setAvatar);
        Bs4MainDispatch.avatarDictionary[key] = avatar;
      } else {
        return {...avatar};
      }
    }

    const link =  Bs4MainDispatch.getUrlPath('showp.php?previewid='+avatar.fileId);

    // console.log('...getAvatar fetch start...', link);
    fetch(link)
    .then(res => {
      // console.log('...getAvatar fetch then...', res);
      return res.blob();
    })
    .then(blob => {
      const newAvatar = Bs4MainDispatch.avatarDictionary[key];
      newAvatar.imageBlobUrl = URL.createObjectURL(blob) || null; 
      newAvatar.setArray.forEach((setItem) => setItem({...newAvatar}));      
    })
    .catch(error => {
      console.log('...getAvatar fetch error...', error)  
    });

    return {...avatar};
  }

  static isDeveloper = () => String(window.location.host).startsWith("localhost:300");

  static getDeveloper = () => {
    if (this.isDeveloper()) {
      return 'bs4/bs4core_jw2/';
      // return 'bs4/bs4core_jw2/'; // P. Jerzy
      // return '/bs4core/jw2/';
      // return '/bs4core/ml2/';
      //return 'Bs4/bs4core/'; // Dominik

      // return '/bs4core/ln_1/';
      //return '/wersje/bs4core/jw2/bs4/';
      //return devPathName;
      //return 'wersje/bs4core/jw/bs4/'
      //return 'wersje/bs4core/wzorcowa/bs4/'
      //<1>//return 'hq/bs4/'      
      //return 'wersje/bs4core/jw2/bs4/'
      //return 'wersje/bs4core/lm/bs4/'
      //return '/hq/bs4/'
      //return 'wersje/bs4core/manual_2/bs4/'
      //https://dev.bs4.eu/wersje/bs4core/manual_2/bs4/index.php
      // return 'wersje/bs4core/pk_1/bs4/'
    }
    return '';
  }

  static getUrl = () => {         
    // const url = window.location.origin+window.location.pathname+this.getDeveloper();
    const url = this.getDeveloper();
    // console.log('...getUrl...', url, window.location);
    return url;
  }
  
  static getUrlPath = (path) => {    
    if (!Bs4Utils.isString(path)) return null;
    return path.startsWith('http') ? path : Bs4MainDispatch.getUrl()+path;
  }

  static updateUrlText = (text) => {  
    if (text && this.isDeveloper()) {
      const url = this.getUrl();
      const start = text.indexOf('http');
      const end = text.indexOf(url);
      // console.log('...HHHH.1.', text);
      // console.log('...HHHH.2.', start, end, url);
      if (start >= 0 && end > start) {
        const text0 = text.substring(0, start);
        const text1 = text.substring(end);
        // console.log('...HHHH.0.', '>'+text0+'<', '>'+text1+'<');
        // console.log('...HHHH.1.', text);
        // console.log('...HHHH.2.', start, end, url);
        return text0+text1;
      }  
    }
    return text;
  }

  // forceLang - ID języka, który narzucamy bo użytkownik nie ma wyboru języka na ekranie
  // langDetails - dodatkowe wytyczne do tego języka np. jest tam pl dla 1
  // skipFirebaseMessaging - jeśli jest i jest ustawione na 1, to nie chcemy prosić użytkownika o zgodę na pushe
  static debugLocale = false;
  static forceLang = null;
  static langDetails = null
  static skipFirebaseMessaging = false;
  static localeModules = {
    date_fns_locale: pl,
    mui_x_date_pickers_locales: plPL,
  };
  static bs4LocaleList = (message) => {
    Bs4I18N.setToPhrase(message?._Komunikat?.phrases);
    Bs4MainDispatch.forceLang = message?._Komunikat?.forceLang;
    Bs4MainDispatch.langDetails = message?._Komunikat?.langDetails;
    Bs4MainDispatch.skipFirebaseMessaging = parseInt(message?._Komunikat?.skipFirebaseMessaging) === 1;    

    const importLocaleFile = (locale) => {
      const localeStr0 = locale.replaceAll('_', '-');
      const localeStr1 = locale.substring(0, 2);
      if (Bs4MainDispatch.debugLocale) console.log('...LOCALE.LOCALE.LOCALE...??', localeStr0);
      import(`date-fns/locale/${localeStr0}/index.js` )
      .then(locale => {
        if (Bs4MainDispatch.debugLocale) console.log('...LOCALE.LOCALE.LOCALE...ok', locale);
        Bs4MainDispatch.localeModules.date_fns_locale = locale.default;
        if (Bs4MainDispatch.debugLocale) console.log('...LOCALE.LOCALE.LOCALE...ok fns', Bs4MainDispatch.localeModules.date_fns_locale);
        setDefaultOptions({locale: Bs4MainDispatch.localeModules.date_fns_locale});
        Bs4MainDispatch.trigger(Bs4MainDispatch.EVENTEMITLOCALE, 1, new Date());
      })
      .catch(error => {
        if (Bs4MainDispatch.debugLocale) console.log('...LOCALE.LOCALE.LOCALE...error', error);
        if (Bs4MainDispatch.debugLocale) console.log('...LOCALE.LOCALE.LOCALE...??', localeStr1);
        import(`date-fns/locale/${localeStr1}/index.js` )
        .then(locale => {
          if (Bs4MainDispatch.debugLocale) console.log('...LOCALE.LOCALE.LOCALE...ok', locale);
          Bs4MainDispatch.localeModules.date_fns_locale = locale.default;
          if (Bs4MainDispatch.debugLocale) console.log('...LOCALE.LOCALE.LOCALE...ok fns', Bs4MainDispatch.localeModules.date_fns_locale);
          setDefaultOptions({locale: Bs4MainDispatch.localeModules.date_fns_locale});
          Bs4MainDispatch.trigger(Bs4MainDispatch.EVENTEMITLOCALE, 2, new Date());
        })
        .catch(error => {
          if (Bs4MainDispatch.debugLocale) console.log('...LOCALE.LOCALE.LOCALE...error', error);
          Bs4MainDispatch.localeModules.date_fns_locale = pl;
          setDefaultOptions({locale: Bs4MainDispatch.localeModules.date_fns_locale});
          Bs4MainDispatch.trigger(Bs4MainDispatch.EVENTEMITLOCALE, 3, new Date());
        })
      })
    };

    const importLocaleFileMUI_x_date_pickers = (locale) => {
      const localeStr = locale.replaceAll('_', '');
      if (Bs4MainDispatch.debugLocale) console.log('...LOCALE.LOCALE.LOCALE.LOCALE...??', localeStr);
      import(`@mui/x-date-pickers/locales/${localeStr}.js` )        
      .then(locale => {
        if (Bs4MainDispatch.debugLocale) console.log('...LOCALE.LOCALE.LOCALE.LOCALE...ok', locale);
        Bs4MainDispatch.localeModules.mui_x_date_pickers_locales = locale[localeStr];
        Bs4MainDispatch.trigger(Bs4MainDispatch.EVENTEMITLOCALE, 4, new Date());
        if (Bs4MainDispatch.debugLocale) console.log('...LOCALE.LOCALE.LOCALE.LOCALE...ok X', Bs4MainDispatch.localeModules.mui_x_date_pickers_locales);
      })
      .catch(error => {
        if (Bs4MainDispatch.debugLocale) console.log('...LOCALE.LOCALE.LOCALE.LOCALE...error', error);          
        Bs4MainDispatch.localeModules.mui_x_date_pickers_locales = plPL;
        Bs4MainDispatch.trigger(Bs4MainDispatch.EVENTEMITLOCALE, 5, new Date());
      })
    };      
            
    const locale = Bs4MainDispatch.langDetails;
    if (Array.isArray(locale)) {
      importLocaleFile(locale[1]);      
      importLocaleFileMUI_x_date_pickers(locale[1]); 
    } else {
      setDefaultOptions({locale: pl});
      Bs4MainDispatch.localeModules.date_fns_locale = pl;
      Bs4MainDispatch.localeModules.mui_x_date_pickers_locales = plPL;
      Bs4MainDispatch.trigger(Bs4MainDispatch.EVENTEMITLOCALE, 6, new Date());
    }
  }

  static useBs4Locale = (props) => {
    const [locale, setLocale] = React.useState([Bs4MainDispatch.localeModules.date_fns_locale, Bs4MainDispatch.localeModules.mui_x_date_pickers_locales, pl, plPL]);
  
    React.useEffect(() => {
      const setNewLocale = (step, date) => {
        if (Bs4MainDispatch.debugLocale) console.log('...LOCALE.LOCALE.LOCALE... trigger', step, Bs4Utils.toDateTime(date))
        setLocale([Bs4MainDispatch.localeModules.date_fns_locale, Bs4MainDispatch.localeModules.mui_x_date_pickers_locales, pl, plPL]);
      }
      Bs4MainDispatch.on(Bs4MainDispatch.EVENTEMITLOCALE, setNewLocale);
  
      return () => {
        Bs4MainDispatch.off(Bs4MainDispatch.EVENTEMITLOCALE, setNewLocale);
      }
    }, [setLocale]);
  
    return locale;
  }

  static getAndroidBs4 = () => {
    try {
      return eval('AndroidBs4')
    } catch (error) {}
    return null;
  }

  static getAppleBs4 = () => {
    try {
      if (window.webkit?.messageHandlers?.isAppleBs4) return window.webkit?.messageHandlers;
    } catch (error) {}
    return null;
  }

  // 2024-06-08 Test (usunąć po testach)

  static getMobile = () => {
    return this.getAndroidBs4() ? 'android' : this.getAppleBs4() ? 'ios' : null;
  }
  
  static sendToMobile = (message) => {
    const mobileMessage = JSON.stringify(message._Komunikat);
    console.log('...Bs4MainDispatch...sendToMobile...', mobileMessage)
    const androidBs4 = Bs4MainDispatch.getAndroidBs4();
    const appleBs4 = Bs4MainDispatch.getAppleBs4();

    if (androidBs4?.receiveMessage) androidBs4.receiveMessage(mobileMessage);
    if (appleBs4?.receiveMessage) appleBs4.receiveMessage.postMessage({"message": mobileMessage});
  }

  static getParserParams(data, bs4KartotekaId) {
    const bs4Kartoteka = Bs4Kartoteka.get(bs4KartotekaId);
    //console.log('=== getParserParams ===', bs4Kartoteka, bs4Kartoteka?.message?._Komunikat?.optionId)
    data.currCardViewId = bs4KartotekaId;
    data.currOptionId = bs4Kartoteka?.message?._Komunikat?.optionId
    data.additionalget = Bs4MainDispatch.additionalget;
    if (this.getMobile()) data.mobiletype = this.getMobile();
    return data;
  }

  static commandParserAfter(bs4KartotekaId) {
    if (Bs4MainDispatch.commandParserWait) {       
      const commandParserWait = Bs4MainDispatch.commandParserWait;
      Bs4MainDispatch.commandParserWait = null;
      let bs4Kartoteka = Bs4Kartoteka.get(bs4KartotekaId);
      if (!bs4Kartoteka) bs4Kartoteka = Bs4Kartoteka.getLast();
      if (bs4Kartoteka) {
        bs4Kartoteka.canClose()
        .then(msg => {
          Bs4MainDispatch.commandParser(commandParserWait.cmd, commandParserWait.details, bs4KartotekaId);          
        })  
        .catch(msg => {
          console.log('=== Error === commandParserAfter', msg)
          Bs4MainDispatch.lastCommandParserAfterRow = null;
        })
      } else {
        console.log('=== Error === commandParserAfter, bs4Kartoteka === null');
      }
      return true;
    }
    return false;
  }    

  static startTime = (() => Bs4MainDispatch.setStartTime ())();

  static setStartTime () {    
    Bs4MainDispatch.startTime = new Date();
    // const locale = String(navigator.language).replace('-', '_');
    const lang = Bs4I18N.getLang();
    Bs4MainDispatch.commandParser('bs4LocaleList', {locale: lang});
    return Bs4MainDispatch.startTime;
  }

  static commandParserWaitForServer = null;

  static commandParserWaitForServerClear() {
    clearTimeout(Bs4MainDispatch.commandParserWaitForServer);
    Bs4MainDispatch.commandParserWaitForServer = null;
  };

  static isCommandParserWaitForServer() {
    if (Bs4MainDispatch.commandParserWaitForServer) {
      console.log('!!! Wait for server !!!');
      return true;
    }
    return false;
  };

  /**
   * 2024-05-16
   * callback
   *
   * It allows you to perform an action after the server's response, or pass an action or parameter to a function (dymek) returned by the server,
   * It can be a function or an object.
   * Usage examples:
   * Bs4Form.atrybOnchange - as a function (allows you to stop the animation on the button after the transmission ends),
   * ASK_TO_CONFIRM - as an object (allows you to pass an action that is launched after selecting ASK_TO_CONFIRM.NO).
   */
  static commandParser (com, data, bs4KartotekaId, callback) {    
    const startTime = new Date();
    data = Bs4MainDispatch.getParserParams(data, bs4KartotekaId);

    if (this.getMobile()) console.log("commandParser:", com);
    else console.log('%c %s ', 'color: darkred; background-color: gold; font-size: 16px;', com);

    const formData = new FormData();
    formData.append('allparams', JSON.stringify(data));
    
    Bs4MainDispatch.commandParserWaitForServerClear();
    Bs4MainDispatch.commandParserWaitForServer = setTimeout(() => {
      Bs4MainDispatch.commandParserWaitForServerClear();
    }, 3000);
    
    fetch(Bs4MainDispatch.getUrlPath(`${Bs4MainDispatch.WEB_PHP_COM}=${com}`), {method: 'POST', body: formData})
    .then(response => response.text())
    .then(returnedText => {
      try {callback()} catch(error){}
      Bs4MainDispatch.commandParserWaitForServerClear();
      if (Bs4MainDispatch.startTime > startTime) {
        console.log('=== deprecated request ===', com, data, bs4KartotekaId, 'start fetch - start program =', startTime - Bs4MainDispatch.startTime)
        return;
      }
  
      try {
        const returnedJson = JSON.parse(returnedText);
        // console.log('...JJJ.1.', returnedText);
        // console.log('...JJJ.2.', JSON.stringify(returnedJson));
        const lastCommandParserAfterRow = Bs4MainDispatch.lastCommandParserAfterRow;
        Bs4MainDispatch.lastCommandParserAfterRow = null;
        Bs4MainDispatch.parsingBs4Response(returnedJson, bs4KartotekaId, lastCommandParserAfterRow, callback);
      } catch (e) {        
        console.log(returnedText, com, data, bs4KartotekaId);
        console.log(e);
      }
    })
    .catch((error) => {
      try {callback()} catch(error){}
      Bs4MainDispatch.commandParserWaitForServerClear();
      console.log('=== fatch catch');
      console.error(error);
    });
  }

  static toBeContinueParsingBs4ResponseMessgs(toBeContinue, bs4Kartoteka) {
    if (!toBeContinue) return;
    Bs4MainDispatch.parsingBs4ResponseToBeContinue(
      toBeContinue.messages, 
      bs4Kartoteka?.bs4KartotekaId || toBeContinue.bs4KartotekaId, 
      toBeContinue.lastCommandParserAfterRow
    );    
  }


  static commandConsole(com, allparams) {
    console.log('commandConsole:', com);
  }

  static async parsingBs4Response(returned, bs4KartotekaId, lastCommandParserAfterRow, callback) {
    const messgs = returned?.messgs;
    if (Array.isArray(messgs) && messgs.length) {
      Bs4MainDispatch.parsingBs4ResponseToBeContinue(messgs, bs4KartotekaId, lastCommandParserAfterRow, callback, Date.now());
    } else {
      //todo error
    }
  }

  static parsingBs4ResponseToBeContinue(messages, bs4KartotekaId, lastCommandParserAfterRow, callback, timeNow) {
    if (this.getMobile()) console.log('parsingBs4ResponseToBeContinue:', 'messgs');
    else console.log('%c %s ', 'color: yellow; background-color: darkred; font-size: 16px', 'messgs');
    console.log([...messages]);
  
    // try {
      Bs4MainDispatch.parsingBs4ResponseMessagges(messages, bs4KartotekaId, lastCommandParserAfterRow, callback, timeNow);
    // } catch (error) {
    //   console.log(error);
    //   console.log('...Error...parsingBs4ResponseMessagges...');
    // }
  }

  static parsingBs4ResponseMessagges (messages, bs4KartotekaId, lastCommandParserAfterRow, callback, timeNow) {
    if (!messages) return;    

    if (!Array.isArray(messages)) messages = [messages]

    if (!messages.length) return;  

    let bs4Kartoteka = Bs4Kartoteka.get(bs4KartotekaId);    
    const message = messages.shift();
    if (message?._Komunikat?.forceCardViewId) {
      bs4Kartoteka = Bs4Kartoteka.get(message._Komunikat.forceCardViewId)
    }

    const toBeContinue = messages.length > 0 ? {
      messages: messages, 
      bs4KartotekaId: bs4KartotekaId, 
      lastCommandParserAfterRow: lastCommandParserAfterRow
    } : null;

    //console.log('%c=== cmd === %s', 'color: yellow; background-color: darkred;', message._Typ);
    //console.log('====== message ======', message._Typ, JSON.stringify(message));
    // if (this.mobiletype) console.log(message._Typ);
    // else 
    if (this.getMobile()) console.log('message._Typ:', message._Typ);
    else console.log('%c %s ', 'color: yellow; background-color: darkred; font-size: 16px', message._Typ);
    console.log({...message});
    // console.log('...toBeContinue...', {...toBeContinue});

    const callbackMessage = callback?._Typ === message._Typ ? callback : null;

    try {
      if (parseInt(message._Komunikat[Bs4MainDispatch.BS4_TOP_MSGS_REFRESH]) === 1) {
        const dateNow  = Date.now();
        if (Bs4AppBar?.instance?.bs4TopMsgsRefresh) Bs4AppBar.instance.bs4TopMsgsRefresh(dateNow, Bs4MainDispatch.BS4_TOP_MSGS_REFRESH);
        window.localStorage.setItem(Bs4MainDispatch.BS4_TOP_MSGS_REFRESH, dateNow);
      }
    } catch(error) {}

    switch (message._Typ) {
      case 'LOGINOK':
        Bs4MainWindow.instance.afterLogin(message);
        break;
        
      case 'SESSION_KILL_ALL':
        //TODO - all JS temp content & session should be killed
        // force to login (full login and password). Clean content after login 
        Bs4MainWindow.instance.sessionKillAll(message);
        break;


      case 'SESSION_EXPIRED':
        // time expired - do not kill the content - just ask for the password again and go back to your work and your cached data
        // Bs4MainWindow.instance.sessionExpired(message);        
        Bs4MainWindow.instance.sessionExpiredMessage(message);        
        break;


      case 'MAINPAGE_DETAILS':
        Bs4MainWindow.instance.newMainPageDetails(message);
        break;


      case 'CARD_DATA':
        Bs4Stores.update(message);
        Bs4MainWindow.newBs4Kartoteka(message, lastCommandParserAfterRow, toBeContinue);
        lastCommandParserAfterRow = null;
        return;
        

      case 'GRID_RELOAD':
        if (! bs4Kartoteka?.gridReload) {
          console.log('...GRID_RELOAD.... NIE MA', bs4Kartoteka)
        }
        const bs4kartotekaReload = Bs4Kartoteka.get(message?._Komunikat?.cardViewRelatedId);
        if (bs4Kartoteka !== bs4kartotekaReload) {
          console.log('...GRID_RELOAD....bs4Kartoteka.!===.bs4kartotekaReload...', bs4Kartoteka, bs4kartotekaReload, message);
        }
        bs4Kartoteka?.gridReload(message);
        break;


      case 'REFRESH_CARD_DATA':
      case 'OPTION_DATA':        
        Bs4Stores.update(message); 
        const bs4KartotekaRight = bs4Kartoteka?.getChildrenRight();
        if (bs4Kartoteka.dockingRegion !== Bs4Kartoteka.DOCKING_REGION_RIGHT && message?._Komunikat?.bs4CardType === '17' && bs4KartotekaRight) {
          if (bs4Kartoteka.currentCardViewId !== bs4KartotekaRight.currentCardViewId) {
            console.log('...currentCardViewId != ...'+message._Typ+'...', bs4Kartoteka.currentCardViewId, bs4KartotekaRight.currentCardViewId);
          }
          bs4Kartoteka = bs4KartotekaRight;
          
        }
        bs4Kartoteka?.setMessage(message, toBeContinue);
        return;


      case 'ONLY_CLOSE_WINDOW':
        //Po zamknięciu kartoteki(WINDOW) pozostałe polecenia będą odnosiły się do kartoteki nadrzędnej (.bs4SourceKartotekaId).
        bs4Kartoteka?.onlyCloseWindow(toBeContinue);
		    return;


      case 'OPEN_NEW_TAB_LOCAL':
        // window.open(Bs4MainDispatch.getUrlPath(`${message._Komunikat.toString()}`));
        Bs4MainWindow.instance.openNewTab(message);
        break;


      case 'OPEN_NEW_TAB_URL':
        //window.open(message._Komunikat.toString());
        // window.open(Bs4MainDispatch.getUrlPath(`${message._Komunikat.toString()}`));
        Bs4MainWindow.instance.openNewTab(message);
        break;


      case 'OPEN_NEW_DOWNLOAD':       
        console.log('...OPEN_NEW_DOWNLOAD...');
        // 2025-02-20 Bs4ViewFile ViewRemote
        // if (callback) callback(message);
        // else 
        Bs4MainWindow.instance.openNewDownload(message);
        break;
        

      case 'TOP_MESSAGES_INFO':
        Bs4AppBar.instance.setTopMessagesInfo(message);
        break;

        
      case 'DELAYED_COUNTERS':             
        bs4Kartoteka?.addDelayedTabsData(message);
        break;


      case 'REQUIRE_MENU_COUNTERS':             
        Bs4MainDispatch.commandParser('Bs4LoadCounter', { currCardViewId: message._Komunikat }, bs4Kartoteka.bs4KartotekaId);
        break;

        
      case 'REMOVE_ELEMENT_DOM':
        bs4Kartoteka?.removeElementDom(message);
        break;


      case 'SHOW_ELEMENT_DOM':
        bs4Kartoteka?.showElementDom(message);
        break;


      case 'CHANGES_SAVED':
        bs4Kartoteka?.changesSaved();
        this.trigger('CHANGES_SAVED', message);
        break;
        
        
      case 'ELEMENT_NEW_VALUE':
        bs4Kartoteka?.elementNewValue(message);
        break;


      case 'ELEMENT_ADD_VALUE':
        bs4Kartoteka?.elementAddValue(message);
        break;

        
      case 'ELEMENT_SET_STORE':
        bs4Kartoteka?.elementSetStore(message);
        break;
        

      case 'NOT_VALID_ELEMENT_DOM':
        bs4Kartoteka?.notValidElementDom(message);
        break;
        

      case Bs4MainDispatch.ASK_TO_CONFIRM:
        bs4Kartoteka?.askToConfirm(message, callbackMessage);
        break;


      case 'BS4_SUGGESTS':
        bs4Kartoteka?.suggestionBs4(message);                
        break;

        
      case 'REDIR_FULL_WINDOW':
        window.location.href = message._Komunikat;
        break;


      case 'LOCALELIST':
        Bs4MainDispatch.bs4LocaleList(message);        
        break;      


      case 'ADDED_VALUE':
        Bs4UxTemplates.addedValue(message._Komunikat);
        break;
        

      case 'uxTemplates': 
        Bs4UxTemplates.updateUxTemplates(message._Komunikat);
        break;


      case 'ASK_CODE_STEP2':
        Bs4MainWindow.instance.setAskCodeStep2(message);
        break;


      case 'FORM_FIELDS_REFRESH':
        Bs4Stores.update(message);
        bs4Kartoteka?.formFieldsRefresh(message);
        break;


      case 'PROGRESS_DETAILS':
        bs4Kartoteka?.setProgressDetails(message);
        break;


      case 'SHOW_TOOLTIP':
        bs4Kartoteka?.showTooltip(message);
        break;


      case 'MENU_STRUCTURE_REFRESH':
        bs4Kartoteka?.menuStructureRefresh(message);
        break;
        

      case 'CHECK_GEOLOCATION':
        geolocation(message);
        break;


      case 'SEND_TO_MOBILE':
        Bs4MainDispatch.sendToMobile(message);
        break;


      case 'PICKER_DATA':
        bs4Kartoteka?.filePickerData(message);
        break;
        

      case 'SHOW_BS4REQUEST':
        Bs4MainWindow.instance.showBs4Request(message);
        break;

        
      case 'ELEMENT_SET_TIMER':
        bs4Kartoteka?.elementSetTimer(message);
        break;

        
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 'CENTER0':
      case 'CENTER1':
      case 'CENTER2':
        // console.log('=== 0 1 2 3 4 ===', message)
        if(message._Komunikat) bs4AddSnackbar(message._Komunikat.toString(), message._Typ, bs4KartotekaId);
        break;      


      case 'CLEAN_MSGS':
        dismissToTime(timeNow || Date.now());
        break;


      default:      
        console.log('=== !!! type error === ', message._Typ);
        break;
    }

    Bs4MainDispatch.parsingBs4ResponseMessagges(messages, bs4KartotekaId, lastCommandParserAfterRow, callback, timeNow);
  }

  static setCurrentDomain = (set) => {
    const domain = set ? window.location.host : null;
    const androidBs4 = Bs4MainDispatch.getAndroidBs4();
    if (androidBs4?.setCurrentDomain) androidBs4.setCurrentDomain(domain);
    const appleBs4 = Bs4MainDispatch.getAppleBs4();
    if (appleBs4?.setCurrentDomain) appleBs4.setCurrentDomain.postMessage({domain : domain});     
  }
}